export default "__VITE_ASSET__BFgVyMNm__"